import * as req from 'api/actions';
import * as c from './constant';

export const generateOVRSReport = (payload, callback) =>
  req.list(
    c.GENERATE_OVRS_REPORT,
    'api/v1/administrators/ovrs/mtpb/check_records',
    payload,
    callback
  );

export const getGeneratedOVRSReport = (payload, callback) =>
  req.list(
    c.GET_GENERATED_OVRS_LISTING,
    '/api/v1/administrators/traffic_violators/apprehensions/report',
    payload,
    callback
  );

  export const checkRecords = (payload, callback) =>
  req.list(
    c.CHECK_RECORDS,
    '/api/v1/administrators/ovrs/mtpb/check_records',
    payload, 
    callback
  )

export const clearSelectedViolation = () =>
  req.setList(c.GENERATE_OVRS_REPORT, []);

export const getPaymentList = (payload = {}, callback) =>
  req.list(
    c.PAYMENT_LIST,
    'api/v1/administrators/traffic_violators/payments/report',
    payload,
    callback
  );

export const getAmnestyList = (payload = {}, callback) =>
  req.list(
    c.AMNESTY_LIST,
    'api/v1/administrators/ovrs/reports/tax_amnesty',
    payload,
    callback
  );
export const getExportsList = (payload = {}, callback) =>
  req.list(
    c.EXPORTS_LIST,
    'api/v1/administrators/report_file_exports',
    payload,
    callback
  );
export const exportPayments = (payload, callback) => 
  req.list(
    c.EXPORT_PAYMENTS,
    'api/v1/administrators/traffic_violators/payments/report_download',
    payload,
    callback
  )

export const exportApprehensions = (payload, callback) => 
  req.list(
    c.EXPORT_APPREHENSIONS,
    '/api/v1/administrators/traffic_violators/apprehensions/report_download',
    payload,
    callback
  )


export const getPreviewLink = (id, payload, callback) => 
  req.item(
    c.GET_PREVIEW_LINK,
    `api/v1/administrators/report_file_exports_download/${id}/preview?bearer_token=${payload.bearer_token}&email=${payload.email}&`,
    callback
  );